import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a1db22c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", {
  class: "el-icon el-icon-eye el-input__icon fas",
  style: {"cursor":"pointer"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Programación según ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("No activa")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" /")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("/ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_ctx.entity)
    ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        model: _ctx.entity,
        rules: _ctx.rules,
        "label-position": "top",
        ref: "form",
        "data-testid": "station-config-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    label: _ctx.$t('label.name')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.name) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "station",
                    label: _ctx.$t('label.identifier')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.station,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity.station) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "apikey",
                    label: _ctx.$t('label.apikey')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.apiKey,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entity.apiKey) = $event)),
                        disabled: "",
                        type: _ctx.apikeyType
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_button, { onClick: _ctx.toogleApikeyType }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "type"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "wake_time",
                    label: _ctx.$t('label.wakeTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.wake_time,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entity.wake_time) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "sleep_time",
                    label: _ctx.$t('label.sleepTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.sleep_time,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entity.sleep_time) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "send_interval",
                    label: _ctx.$t('label.sendInterval')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.send_interval,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entity.send_interval) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "function_mode",
                    label: _ctx.$t('label.functionMode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.function_mode,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.entity.function_mode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "phone",
                    label: _ctx.$t('label.massCapture')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.phone,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entity.phone) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    bluetooth: "angle",
                    label: _ctx.$t('label.bluetooth')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.bluetooth,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.entity.bluetooth) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "position",
                    label: _ctx.$t('label.position')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.position,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.entity.position) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "variation",
                    label: _ctx.$t('label.variation')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.entity.variation,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.entity.variation) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                lg: 24,
                class: "mb-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.interval")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { lg: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "interval" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.threshold')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.entity.threshold,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.entity.threshold) = $event)),
                                    type: "number"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { gutter: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: _ctx.$t('label.night')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.entity.night,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.entity.night) = $event)),
                                    type: "number"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.entity.massiveCapture)
            ? (_openBlock(), _createBlock(_component_el_card, {
                key: 0,
                shadow: "never"
              }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.massiveCapture")) + " ", 1),
                  _createVNode(_component_el_switch, {
                    onChange: _ctx.updatedPathPart1,
                    modelValue: _ctx.entity.massiveCapture.active,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.entity.massiveCapture.active) = $event))
                  }, null, 8, ["onChange", "modelValue"]),
                  _hoisted_2,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.entity.massiveCapture.type,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entity.massiveCapture.type) = $event)),
                    placeholder: "Select",
                    style: {"width":"240px"},
                    disabled: !_ctx.entity.massiveCapture.active,
                    onChange: _ctx.getInfoSamplingPoint
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "onChange"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 12 }, {
                    default: _withCtx(() => [
                      (_ctx.entity.massiveCapture.type === 'timetable')
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Fecha de inicio" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.entity.massiveCapture.fromDateTime,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.entity.massiveCapture.fromDateTime) = $event)),
                                    type: "datetime",
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    disabled: !_ctx.entity.massiveCapture.active
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.entity.massiveCapture.type === 'timetable')
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 1,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Fecha de fin" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.entity.massiveCapture.toDateTime,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.entity.massiveCapture.toDateTime) = $event)),
                                    type: "datetime",
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    disabled: !_ctx.entity.massiveCapture.active
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.entity.massiveCapture.type === 'tmoa')
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 2,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Tipologías de agua" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.entity.massiveCapture.typeTMOA,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.entity.massiveCapture.typeTMOA) = $event)),
                                    multiple: "",
                                    placeholder: "Please select",
                                    style: {"width":"240px"},
                                    "value-key": "value"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmoasOptions, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.label,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.entity.massiveCapture.type === 'tmoa')
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 3,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Estado" }, {
                                default: _withCtx(() => [
                                  (_ctx.entity.massiveCapture.activeTMOA)
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 0,
                                        type: "success"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.tmoaActiveName), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 1,
                                        type: "info"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_3
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "Configurar ruta",
                            disabled: !_ctx.entity.massiveCapture.active
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.path1,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.path1) = $event)),
                                style: {"max-width":"300px"},
                                placeholder: "Código",
                                disabled: !_ctx.entity.massiveCapture.active,
                                onInput: _ctx.updatedPath
                              }, null, 8, ["modelValue", "disabled", "onInput"]),
                              _hoisted_5,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.entity.massiveCapture.camera,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.entity.massiveCapture.camera) = $event)),
                                placeholder: "Cámara",
                                "value-key": "code",
                                disabled: !_ctx.entity.massiveCapture.active,
                                onChange: _ctx.updatedPath
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entity.stationsCamera, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.camera.code,
                                      label: item.camera.code,
                                      value: item.camera.code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "onChange"]),
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createTextVNode(" Ruta: " + _toDisplayString(_ctx.entity.massiveCapture.path), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"]))
    : _createCommentVNode("", true)
}